import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import * as color from '../../config/colors';
import * as background from '../../config/backgroundColor';
import * as series from '../../config/series';
import * as tooltip from '../../config/tootip';

import { CommonService } from '../../service/common.service';
import { EChartOption } from 'echarts';
import { ChartOptionService } from '../../service/chart-option.service';

@Injectable({
  providedIn: 'root'
})
export class DrillDownMapService {

  constructor(
    private commonService: CommonService,
    private chartOptionService: ChartOptionService
  ) { }

  // 设置smallMode
  setSmallModePadding(component) {
    component.cardPadding = "0rem";
  }

  // 更改标题栏的暗色模式
  changeChartTitleDark(component, darkMode: boolean) {
    if (darkMode) {
      component.chartTitleColor = color.darkModeTextColor;
      component.cardBgColor = background.darkModeBGColor;
    }
  }
  // 背景色 darkMode
  chartBackgroundColorDarkMode(chartOption) {
    chartOption.backgroundColor = background.darkModeBGColor;
  }

  // 文字颜色DarkMode
  colorsDarkMode(chartColor: string[]) {
    chartColor.length = 0;
    color.darkModeColors.forEach(e => {
      chartColor.push(e)
    })
  }

  // 系列的darkMode
  seriesDarkMode(seriesOption: EChartOption.Series) {
    if (_.isNil(seriesOption['label'])) {
      seriesOption['label'] = {};
    }
    seriesOption['label']['color'] = color.darkModeTextColor;
  }

  // 获取geo
  getChartGeo() {
    let geoOption = this.chartOptionService.getDefaultGeo();
    geoOption['selectedMode'] = true;
    geoOption['label']['show'] = true;
    return geoOption;
  }

  // 获取散点地图tooltip
  getScatterMapTooltip() {
    return tooltip.getTooltipOfPointMap();
  }

  // 获取散点系列
  getMapScatterSeries() {
    let seriesOption: EChartOption.Series = this.chartOptionService.getMapScatterSeries();
    return seriesOption;
  }

  // 设置visualMap的位置
  setVisualMapPosition(visualMapOption, position) {
    visualMapOption['left'] = position;
  }

  setVisualMapDimension(chartVisualMap, dimension) {
    chartVisualMap.dimension = dimension;
  }

  // setDimensionNames(chartSeriesList, dimensionNames, tooltipOption: EChartOption.Tooltip) {
  //   let names = [], units = [];
  //   if (_.isNil(dimensionNames)) {
  //     return
  //   }

  //   for (const iterator of dimensionNames) {
  //     names.push(iterator.dimensionName)
  //     units.push(iterator.unit)
  //   }
  //   let pointName = ['lng', 'lat'];
  //   pointName = pointName.concat(names);

  //   chartSeriesList[0].dimensions = pointName;
  //   tooltipOption.formatter = tooltip.getTooltipOfPointMap(units).formatter;

  // }
  setDimensionNames(scatterSeriesOpt, dimensionNames, tooltipOption: EChartOption.Tooltip) {
    let names = [], units = [];
    if (_.isNil(dimensionNames)) {
      return
    }

    for (const iterator of dimensionNames) {
      names.push(iterator.dimensionName)
      units.push(iterator.unit)
    }
    let pointName = ['lng', 'lat'];
    pointName = pointName.concat(names);

    scatterSeriesOpt.dimensions = pointName;
    
    tooltipOption.formatter = tooltip.getTooltipOfPointMap(units).formatter;
  }

  // 构建series
  buildSeries(chartData: any, chartVisualMap, seriesList: EChartOption.Series[], scatterSeriesOpt: EChartOption.Series) {
    seriesList.length = 0;
    if (chartData && chartData.hasOwnProperty('visualMap')) {
      chartVisualMap.type = chartData.visualMap.type;
      chartVisualMap.pieces = chartData.visualMap.data;
    }
    let scatterSeries: EChartOption.Series = _.cloneDeep(scatterSeriesOpt);

    if (chartData && chartData.hasOwnProperty('scatterData') && !_.isNil(chartData.scatterData)) {
      scatterSeries['data'] = chartData.scatterData;
      if (!scatterSeries.hasOwnProperty('label')) {
        scatterSeries['label'] = {}
      }
      scatterSeries['label']['show'] = true;
    }

    seriesList.push(scatterSeries);
    // if (chartData.hasOwnProperty('seriesName')) {
    //   for (let i = 0; i < chartData.seriesName.length; i++) {
    //     let scatterSeries: EChartOption.Series = _.cloneDeep(scatterSeriesOpt)
    //   }
    // }
  }
}
